import React, { Component } from 'react';

var Carousel = require('nuka-carousel');

class Slider extends Component {
  state = {
    slideIndex: 0
  };


  render () {
    const sliderButton = {
      border: 0,
      background: 'rgba(0, 0, 0, 0.4)',
      color: 'white',
      padding: '10px',
      margin:'0 20px',
      outline: 0,
      opacity: 1,
      cursor: 'pointer',
      fontSize: '30px',
      fontWeight: 'bold',
    }
    return (
      <Carousel 
        autoplay
        wrapAround
        renderCenterLeftControls={({ previousSlide }) => (
          <button onClick={previousSlide} style={sliderButton}>{`<`}</button>
        )}
        renderCenterRightControls={({ nextSlide  }) => (
          <button style={sliderButton} onClick={nextSlide }>></button>
        )} 
      >
        <img src={require('../img/slider/1.jpg')} alt="" />
        <img src={require('../img/slider/2.jpg')} alt="" />
        <img src={require('../img/slider/3.jpg')} alt="" />
      </Carousel>
    );
  }
};

export default Slider;



/** WEBPACK FOOTER **
 ** ./src/components/Slider.js
 **/


/** WEBPACK FOOTER **
 ** ./src/components/Slider.js
 **/